import Loading from '../../../components/Loading';
import useEditNotice from './useEditNotice';
import NoticeForm from '../components/NoticeForm';

export default function EditNotice() {
    const {
        isLoading,
        notice,
        handleSubmit
    } = useEditNotice();

    return (
        <Loading loading={isLoading} >
            <NoticeForm action='Editar' notice={notice} key={notice?.id} onSubmit={handleSubmit} />
        </Loading>
    )
}
